import { useNavigate } from "react-router-dom"; 
import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LoadingOverlay from 'react-loading-overlay-ts';
import MuiDialogAlert from '../components/MuiDialogAlert';

import axios from 'axios';

import { loadSettings, checkNumeric } from '../components/Functions'


const col1_width = "200px";
const col2_width = "50px";
const col3_width = "200px";

const form_target_list_numeric = [
    "sms_1",
    "sms_2"
]

const Settings = () => {

    let navigate = useNavigate();

    const [formData, setFormData] = useState({
        "sms_1": "",
        "sms_2": ""
    })
    const [settings, setSettings] = useState({})
    const [loadingActive, setLoadingActive] = useState(false);
    const [initLoad, setInitLoad] = useState(false)
    const [pageLoaded, setPageLoaded] = useState(false)

    const [modalHeader, setModalHeader] = useState("");
    const [modalBody, setModalBody] = useState("");
    const [modalHtml, setModalHtml] = useState("");
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);

    
    useEffect(() => {

        const getSettings = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getSettings";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });

                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }


                console.log(loadSettings(response.data));

                // Set the retrieved data to the state
                setSettings(loadSettings(response.data));
                setInitLoad(true)
                console.log("Set Setting finished")
                setLoadingActive(false);

            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                setModalHeader("Error")
                setModalBody("Unable to load settings data")
                setShowModal(true) 
               
            }
        };

        setLoadingActive(true);
        getSettings()

    }, [])

    useEffect(() => {
        if (initLoad) {
            updateFormData("sms_1", settings.sms.sms_1.substring(3))
            updateFormData("sms_2", settings.sms.sms_2.substring(3))
            setPageLoaded(true)
        }
    },[settings])



    function updateForm(e) {
        console.log(e)

        if (form_target_list_numeric.includes(e.target.id)) {
            if (checkNumeric(e.target.value)){
                updateFormData(e.target.id, e.target.value)
            }
        }
    }
    

    function updateFormData(id, val) {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [id]: val,
        }));
    }    

    function save_btn_click(){
        
        if (checkFormDataValid()){
            let url = process.env.REACT_APP_API_SERVER + "/updateSmsSettings";
            let post_data = {}
    
            if (formData.sms_1 !== ""){
                post_data.sms_1 = "+65" + formData.sms_1
            }
            else{
                post_data.sms_1 = formData.sms_1
            }
    
            if (formData.sms_2 !== ""){
                post_data.sms_2 = "+65" + formData.sms_2
            }
            else {
                post_data.sms_2 = formData.sms_2
            }

            post_data.api_user = JSON.parse(localStorage.getItem('user'))

            setLoadingActive(true)
    
            axios.post(url,post_data)
            .then(function (response) {
                    let data = response.data;
                    console.log(data)
                    if (data.rowCount > 0){
                        setModalHeader("")
                        setModalHtml("Update Successful")
                        setShowModal(true)                        
                    }
                    setLoadingActive(false)
                })
                .catch(function (error) {
                    setLoadingActive(false)
                });
        }

    }

    function checkFormDataValid(){
        let err_msg = ""

        if (formData.sms_1 !== ""){
            if (formData.sms_1.length > 8){
                err_msg += "<div>SMS Number 1 is too long</div>"
            }
    
            if (formData.sms_1.length < 8){
                err_msg += "<div>SMS Number 1 is too Short</div>"
            }
        }

        if (formData.sms_2 !== "") {
            if (formData.sms_2.length > 8){
                err_msg += "<div>SMS Number 2 is too long</div>"
            }

            if (formData.sms_2.length < 8){
                err_msg += "<div>SMS Number 2 is too Short</div>"
            }
        }


        if (err_msg !== ""){
            setModalHeader("ERROR")
            setModalHtml(err_msg)
            setShowModal(true)
            return false
        }

        return true
    }
    

    return (
        <main>

            <div align="left" style={{ height: "100%" }}>
                <LoadingOverlay
                    active={loadingActive}
                    spinner
                    text="Loading ..."
                >
            {
                pageLoaded &&
                <>

                <div className='page_title'>Settings</div>

                <div>
                    <table>
                        <tbody>
                            <tr height="60px">
                                <td valign="center" width={col1_width} className="form-labels valign-center">SMS Number 1</td>
                                <td align="right" width={col2_width} className="form-labels" style={{paddingRight: "10px"}}>+65</td>

                                <td align='left' width={col3_width} className='valign-center'>

                                    <TextField
                                        id="sms_1"
                                        className='form-textfield'
                                        onChange={updateForm}
                                        value={formData.sms_1}
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 }
                                        }}
                                    />

                                </td>
                            </tr>
                            <tr height="60px">
                                <td valign="center" width={col1_width} className="form-labels valign-center">SMS Number 2</td>
                                <td align="right" width={col2_width} className="form-labels" style={{ paddingRight: "10px" }}>+65</td>
                                <td align='left' width={col3_width} className='valign-center'>
                                    <TextField
                                        id="sms_2"
                                        className='form-textfield'
                                        onChange={updateForm}
                                        value={formData.sms_2}
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 }
                                        }}
                                    />

                                </td>
                            </tr>
                            <tr height="100px">
                                <td valign="center" width={col1_width} className="form-labels valign-center">
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={save_btn_click}
                                        sx={{ width: 200, height: 50 }}
                                    >
                                        Update Settings
                                    </Button> 
                                </td>
                                <td align='left' width={col2_width} className='valign-center'>



                                </td>
                            </tr>
                        
                        </tbody>
                    </table>
                </div>
            </>
            }

                    <MuiDialogAlert
                        showModal={showModal}
                        handleClose={handleClose}
                        html={modalHtml}
                        bodyContent={modalBody}
                        title={modalHeader}
                        bodyClass="whitespace"
                    />


                </LoadingOverlay>
            </div>        

        </main>
    )
}

export default Settings